export default __webpack_public_path__ + "static/media/pdffEncrypt.5b197357.svg";